// src/pages/MicrosoftCallback.jsx
import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const MicrosoftCallback = () => {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        if (error) {
          // Send error to parent window
          window.opener?.postMessage({
            type: 'MICROSOFT_AUTH_ERROR',
            error: errorDescription || error
          }, window.location.origin);
          window.close();
          return;
        }

        if (!code) {
          window.opener?.postMessage({
            type: 'MICROSOFT_AUTH_ERROR',
            error: 'No authorization code received'
          }, window.location.origin);
          window.close();
          return;
        }

        // Send authorization code to parent window for backend processing
        window.opener?.postMessage({
          type: 'MICROSOFT_AUTH_SUCCESS',
          code: code
        }, window.location.origin);

        window.close();
      } catch (error) {
        console.error('Microsoft callback error:', error);
        window.opener?.postMessage({
          type: 'MICROSOFT_AUTH_ERROR',
          error: error.message || 'Authentication failed'
        }, window.location.origin);
        window.close();
      }
    };

    handleCallback();
  }, []);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography variant="body1">
        Completing Microsoft authentication...
      </Typography>
    </Box>
  );
};

export default MicrosoftCallback;